import React, { useContext } from 'react';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Button, Popconfirm, Space, Tooltip } from 'antd';
import { ColumnProps } from 'antd/lib/table';

import EventConfigurationContext from '@totem/components/services/threats/configuration/EventConfigurationContext';
import { EventCategory } from '@totem/components/services/threats/configuration/types';
import IBTable from '@totem/components/ui_components/antDesignOverrides/IBTable';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';

const EventCategoriesTable = () => {
  const { userProfile } = useContext(UserProfileContext);
  const { loading, categories, onEditCategory, onDeleteCategory } = useContext(
    EventConfigurationContext,
  );

  const canEdit =
    permissions.internalSystemAdministrator.hasPermissions(userProfile);

  const columns: ColumnProps<EventCategory>[] = [
    {
      title: 'ID',
      key: 'id',
      width: 160,
      sorter: (left, right) => left.id.localeCompare(right.id),
      defaultSortOrder: 'ascend',
      render: (_, record) => <code>{record.id}</code>,
    },
    {
      title: 'Name',
      key: 'name',
      sorter: (left, right) => left.name.localeCompare(right.name),
      render: (_, record) => <span>{record.name}</span>,
    },
    {
      title: 'Description',
      key: 'description',
      render: (_, record) => <span>{record.description}</span>,
    },
    {
      title: '',
      key: 'actions',
      width: 80,
      render: (_, record) =>
        canEdit ? (
          <Space>
            <Tooltip title="Edit">
              <Button
                size="small"
                icon={<EditOutlined />}
                onClick={() => onEditCategory(record)}
              />
            </Tooltip>
            <Popconfirm
              title="Delete this category?"
              description="This cannot be undone."
              onConfirm={() => onDeleteCategory(record.id)}
              okText="Delete"
              okButtonProps={{ danger: true }}
            >
              <Tooltip title="Delete">
                <Button size="small" icon={<DeleteOutlined />} danger />
              </Tooltip>
            </Popconfirm>
          </Space>
        ) : null,
    },
  ];

  return (
    <IBTable
      rowKey={(record) => record.id}
      columns={columns}
      dataSource={categories}
      loading={loading}
      pagination={{ defaultPageSize: 10, showSizeChanger: true }}
    />
  );
};

export default EventCategoriesTable;
